import React, { useState } from 'react'
import parser from 'react-html-parser'
import { Grid } from "@material-ui/core"
import { BannerButtons, MainBannerSlideData, MGMMainBannerButtons } from '@interfaces/portal'
import { useMedia } from '@commons/media'
import {Link} from 'react-scroll'
import './index.scss'
import { useTranslation } from 'react-i18next';
import { base64Decode } from '@commons/util'

interface MainBannerSlideProps {
    data: MainBannerSlideData
}

const MainBannerSlides: React.FC<MainBannerSlideProps> = (props) => {
    const {mbMatches, mdMatches, tlMatches, webMatches, minWebMatches, bigWebMatches, mediaClass} = useMedia();
    const {i18n} = useTranslation();
    
    const {
        data
    } = props;
    
    const goLinkUrl = (link: string) => {
        window.location.href = link
    }

    const BannerButton = (props: MGMMainBannerButtons) => {
        // linkType 1 link 2 anchor
        const {
            linkType,
            linkUrl,
            buttonText,
            color,
        } = props;

        return (
            linkType === '1' ? 
            <Grid item className={`${mediaClass('slide-right-btn')}`}  style={{backgroundColor: color}} onClick={() => goLinkUrl(linkUrl)}>
                <div>{parser(base64Decode(buttonText))}</div>
            </Grid> :
            <Link 
                to={linkUrl || ""} 
                smooth="easeOutQuad" 
                duration={800}
                offset={-window.innerHeight / 5}
            >
                <Grid item className={`${mediaClass('slide-right-btn')}`}  style={{backgroundColor: color}}>
                    <div>{parser(base64Decode(buttonText))}</div>
                </Grid>
            </Link>
        )
    }

    return (
        <Grid container className={`${mediaClass('mainbanner-slide-item')}`}>
            <Grid item xs={mbMatches ? 12 : 6} className={`${mediaClass('slide-left-wrapper')}`}>
                {/* {
                    mbMatches ? <div className='slide-left-img' ><img src={data.mobileBannerImageUrl} style={{width: '100%'}} alt="" /></div> : <></>
                }
                {
                    tlMatches ? <div className='slide-left-img'><img src={data.mobileBannerImageUrl} style={{width: '100%'}} alt="" /></div> : <></>
                }
                {
                    webMatches ? <div className='slide-left-img'><img src={data.desktopBannerImageUrl} style={{width: '100%'}} alt="" /></div> : <></>
                } */}
                {
                    mbMatches ? <div className='slide-left-img' style={{backgroundImage: `url(${data.mobileBannerImageUrl})`}}></div> : <></>
                }
                {
                    tlMatches ? <div className='slide-left-img' style={{backgroundImage: `url(${data.tabletBannerImageUrl})`}}></div> : <></>
                }
                {
                    minWebMatches ? <div className='slide-left-img' style={{backgroundImage: `url(${data.desktopBannerImageUrl})`}}></div> : <></>
                }
                {
                    webMatches && !bigWebMatches ? <div className='slide-left-img web-matches' style={{backgroundImage: `url(${data.desktopBannerImageUrl})`}}></div> : <></>
                }
                {
                    bigWebMatches ? <div className='slide-left-img' style={{backgroundImage: `url(${data.desktopBannerImageUrl})`}}></div> : <></>
                }
            </Grid>
            <Grid container item xs={mbMatches ? 12 : 6} className={`${mediaClass('slide-right-wrapper')}`}>
                <Grid container className={`${mediaClass('slide-right-content')}`} direction='column' wrap='nowrap'>
                    <div className={`${mediaClass('slide-right-text1')}`}>
                        {parser(base64Decode(props.data.subTitle))}
                    </div>
                    <Grid container item direction='row' justifyContent={mdMatches||tlMatches||webMatches ? 'flex-start':'space-around'} wrap="nowrap" alignItems='center' className='slide-right-button-group'>
                        {
                            data.bannerButtons.length ? data.bannerButtons.map((btn:MGMMainBannerButtons, i: number) => (
                               <BannerButton key={i} 
                                linkType={btn.linkType}
                                linkUrl={btn.linkUrl}
                                buttonText={btn.buttonText}
                                color={btn.color}
                               ></BannerButton>
                            )) : <></>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default MainBannerSlides